import React from 'react'
import { MenuItem, MenuList, Typography } from '@material-ui/core'

import MoreVertMenu from 'app/componentV4/Menu/MoreVertMenu'
import { FormattedMessage } from 'react-intl'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'

function GroupSubscriberTableAction({
  subscriber,
  group,
  onOpenDeleteGroupDialog,
}) {
  return (
    <>
      <MoreVertMenu icon="more_vert">
        {(closeMenu) => (
          <MenuList className="w-full">
            <MenuItem
              onClick={() => {
                onOpenDeleteGroupDialog({
                  subscriberIds: [subscriber.id],
                  groupId: group.id,
                })
                closeMenu()
              }}
              className="space-x-5"
            >
              <DeleteOutlineIcon fontSize="small" className="text-red-500" />
              <Typography className="text-14 font-400 text-red-500">
                <FormattedMessage id="action.remove" />
              </Typography>
            </MenuItem>
          </MenuList>
        )}
      </MoreVertMenu>
    </>
  )
}

export default GroupSubscriberTableAction
